


















































import Vue from "vue";
import { Form } from "@/utils/Form/Form";
import { validateEmailAddress, validateWebsiteAddress } from "@timesheets/validators-common";
import { Contact, Signup } from "@timesheets/constants-common";
import { Accounts } from "@timesheets/routes-api-common";
import "./scss";
import { RecordAny } from "@gemma/typescript-types";
import { GemmaError } from "@gemma/errors";
import { setMetaDescription } from "@/utils/setMetaDescription";
import Common from "../Common/Index.vue";

export default Vue.extend({
  name: "Signup",

  extends: Form,
  components: {
    Common,
  },

  data() {
    return {
      route: Accounts.Signup.Local.Signup,
      form: {
        agencyName: null,
        telephoneNumber: null,
        websiteAddress: null,
        fullname: null,
        emailAddress: null,
        terms: false,
      },
    };
  },

  mounted() {
    setMetaDescription("Sign up your business for a SaveTrees Online Timesheets account");
  },

  methods: {
    validate(form: RecordAny, errors: GemmaError[]) {
      if (!form.agencyName) {
        errors.push(Signup.Errors.AgencyName);
      }

      if (form.websiteAddress) {
        validateWebsiteAddress({ websiteAddress: form.websiteAddress }, errors, { group: "Signup", updateModel: false });
      }

      Contact.validate(form, errors, undefined, "Signup", Signup.Errors);
      validateEmailAddress(form.emailAddress, errors, undefined, "Signup", { checkCasing: false, Errors: Signup.Errors });

      if (!form.telephoneNumber) {
        errors.push(Signup.Errors.TelephoneNumber);
      }

      if (!form.terms) {
        errors.push(Signup.Errors.Terms);
      }
    },
  },
});
